import { format } from 'date-fns';

const fullDateFormat = 'MMMM d, yyyy HH:mm:ss';
const yearMonthDayFormat = 'yyyy-MM-dd';
const slashYearMonthDayFormat = 'yyyy/MM/dd';
const hourMinuteSecondFormat = 'HH:mm:ss';
const hourMinuteFormat = 'HH:mm';

const unixTimestampToDateUTC = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000);
    return date.toUTCString();
};


const unixTimestampToDate = (unixTimestamp, dateFormat) => {
    const date = new Date(unixTimestamp * 1000);

    if (dateFormat == hourMinuteFormat) {
        return date.getHours() + ':' + date.getMinutes();
    }

    if (dateFormat == hourMinuteSecondFormat) {
        return date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    }

    dateFormat = dateFormat || fullDateFormat;
    return format(date, dateFormat);
};

const unixTimestampToTimeAgo = (unixTimestamp) => {
    const now = Date.now() / 1000; // Current time in seconds
    const diff = now - unixTimestamp; // Difference in seconds

    if (diff < 60) {
    return `${Math.floor(diff)} seconds ago`;
    } else if (diff < 3600) {
    return `${Math.floor(diff / 60)} minutes ago`;
    } else if (diff < 86400) {
    return `${Math.floor(diff / 3600)} hours ago`;
    } else {
    return `${Math.floor(diff / 86400)} days ago`;
    }
};

const setTimeToUnixTimestamp = (unixTimestamp, unixTimestamp2) => {
    // Convert startDate to a Date object
    const dateFromStartDate = new Date(unixTimestamp * 1000);

    // Extract time components from startDate2
    const timeDate = new Date(unixTimestamp2 * 1000);
    const hours = timeDate.getUTCHours();
    const minutes = timeDate.getUTCMinutes();
    const seconds = timeDate.getUTCSeconds();

    // Set the time on the date from startDate
    dateFromStartDate.setUTCHours(hours, minutes, seconds);

    // Return the new Unix timestamp
    return Math.floor(dateFromStartDate.getTime() / 1000);
};

// returns currentTimestamp like 1726498189
const currentTimestamp = () => {
    return Math.floor(Date.now() / 1000);
};


export {
    setTimeToUnixTimestamp,
    unixTimestampToDateUTC,
    unixTimestampToDate,
    unixTimestampToTimeAgo,
    currentTimestamp,
    fullDateFormat,
    yearMonthDayFormat,
    hourMinuteSecondFormat,
    slashYearMonthDayFormat,
};